"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPropertiesResponse$ = exports.StatsPropertiesResponse$outboundSchema = exports.StatsPropertiesResponse$inboundSchema = void 0;
exports.statsPropertiesResponseToJSON = statsPropertiesResponseToJSON;
exports.statsPropertiesResponseFromJSON = statsPropertiesResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiesstatswrapper_js_1 = require("./propertiesstatswrapper.js");
/** @internal */
exports.StatsPropertiesResponse$inboundSchema = z.object({
    data: propertiesstatswrapper_js_1.PropertiesStatsWrapper$inboundSchema,
});
/** @internal */
exports.StatsPropertiesResponse$outboundSchema = z.object({
    data: propertiesstatswrapper_js_1.PropertiesStatsWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsPropertiesResponse$;
(function (StatsPropertiesResponse$) {
    /** @deprecated use `StatsPropertiesResponse$inboundSchema` instead. */
    StatsPropertiesResponse$.inboundSchema = exports.StatsPropertiesResponse$inboundSchema;
    /** @deprecated use `StatsPropertiesResponse$outboundSchema` instead. */
    StatsPropertiesResponse$.outboundSchema = exports.StatsPropertiesResponse$outboundSchema;
})(StatsPropertiesResponse$ || (exports.StatsPropertiesResponse$ = StatsPropertiesResponse$ = {}));
function statsPropertiesResponseToJSON(statsPropertiesResponse) {
    return JSON.stringify(exports.StatsPropertiesResponse$outboundSchema.parse(statsPropertiesResponse));
}
function statsPropertiesResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsPropertiesResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsPropertiesResponse' from JSON`);
}
//# sourceMappingURL=statspropertiesresponse.js.map